import { render } from "./PreviewSubmission.vue?vue&type=template&id=3d73869c"
import script from "./PreviewSubmission.vue?vue&type=script&lang=js"
export * from "./PreviewSubmission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__